// extracted by mini-css-extract-plugin
module.exports = {"apiClientImg":"Authorize_apiClientImg__3MUXN"};